"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ProjectDetailLinkUnauthorized = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProjectDetailLinkUnauthorized, _React$PureComponent);

  function ProjectDetailLinkUnauthorized(props) {
    _classCallCheck(this, ProjectDetailLinkUnauthorized);

    return _possibleConstructorReturn(this, (ProjectDetailLinkUnauthorized.__proto__ || Object.getPrototypeOf(ProjectDetailLinkUnauthorized)).call(this, props));
  }

  _createClass(ProjectDetailLinkUnauthorized, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      if (!this.props.create) return /*#__PURE__*/_react.default.createElement("span", {
        className: "comp-detail-link-unauthorized center"
      }, t('Angemeldet'));
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "comp-detail-link-unauthorized center"
      }, t('no data'));
    }
  }]);

  return ProjectDetailLinkUnauthorized;
}(_react.default.PureComponent);

ProjectDetailLinkUnauthorized.propTypes = {
  t: _propTypes.default.func.isRequired,
  create: _propTypes.default.bool
};
module.exports = ProjectDetailLinkUnauthorized;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-detail-link/unauthorized.js
// module id = 705
// module chunks = 0